import { Controller } from '@hotwired/stimulus';
import { sendAlert } from './noti_controller';

export default class extends Controller {
  static targets = [
    'nameInput',
    'contactsFileInput',
    'xlsUploadToggle',
    'csvUpload',
    'individualUpload',
    'contacts',
    'contact',
    'contactInputContainer',
    'form',
  ];
  static values = {};

  #template = `
    <tr class="border-b border-coolgray-300" data-address-book-target="contact">
      <td class="px-2 py-2 w-[16%]">{{name}}</td>
      <td class="px-2 py-2 w-[26%]">{{email}}</td>
      <td class="px-2 py-2 w-[21%]">{{phoneNumber}}</td>
      <td class="px-2 py-2 w-[20%]">{{memo}}</td>
      <td class="px-2 py-2 w-[17%] text-right">
        <button class="px-4 py-1 border border-coolgray-300 rounded hover:bg-coolgray-500 hover:text-white"
                data-action="click->address-book#deleteContact">삭제
        </button>
      </td>
    </tr>`;

  connect() {
    this.xlsUploadToggleTarget.click();
  }

  toggleXlsUpload() {
    this.csvUploadTarget.classList.remove('hidden');
    this.individualUploadTarget.classList.add('hidden');
  }

  toggleIndividualUpload() {
    this.individualUploadTarget.classList.remove('hidden');
    this.csvUploadTarget.classList.add('hidden');
  }

  addContact(e) {
    e.preventDefault();

    const nameInput = this.contactInputContainerTarget.querySelector('td:nth-child(1) > input');
    const emailInput = this.contactInputContainerTarget.querySelector('td:nth-child(2) > input');
    const phoneNumberInput = this.contactInputContainerTarget.querySelector('td:nth-child(3) > input');
    const memoInput = this.contactInputContainerTarget.querySelector('td:nth-child(4) > input');

    if (!this.validateContact(nameInput.value, emailInput.value, phoneNumberInput.value, memoInput.value)) {
      return;
    }

    let contact = this.#template;
    contact = contact.replace('{{name}}', nameInput.value);
    contact = contact.replace('{{email}}', emailInput.value);
    contact = contact.replace('{{phoneNumber}}', phoneNumberInput.value);
    contact = contact.replace('{{memo}}', memoInput.value);
    this.contactsTarget.insertAdjacentHTML('beforeend', contact);

    nameInput.value = '';
    emailInput.value = '';
    phoneNumberInput.value = '';
    memoInput.value = '';
  }

  isEmptyContactInputs() {
    const nameInputValue = this.contactInputContainerTarget.querySelector('td:nth-child(1) > input').value;
    const emailInputValue = this.contactInputContainerTarget.querySelector('td:nth-child(2) > input').value;
    const phoneNumberInputValue = this.contactInputContainerTarget.querySelector('td:nth-child(3) > input').value;
    const memoInputValue = this.contactInputContainerTarget.querySelector('td:nth-child(4) > input').value;

    return (
      nameInputValue.trim().length === 0 &&
      emailInputValue.trim().length === 0 &&
      phoneNumberInputValue.trim().length === 0 &&
      memoInputValue.trim().length === 0
    );
  }

  deleteContact(e) {
    e.preventDefault();
    const tr = e.target.parentElement.parentElement;
    if (tr.tagName !== 'TR') {
      return;
    }
    tr.remove();
  }

  save(e) {
    e.preventDefault();
    if (this.xlsUploadToggleTarget.checked) {
      this.formTarget.submit();
      return;
    }
    if (!this.isEmptyContactInputs()) {
      sendAlert('저장 전 추가 버튼을 눌러주세요.');
      return;
    }

    if (!this.validateAddressBook()) {
      return;
    }

    const contacts = this.contactTargets;
    for (let i = 0; i < contacts.length; i++) {
      const name = contacts[i].querySelector('td:nth-child(1)').innerText;
      const email = contacts[i].querySelector('td:nth-child(2)').innerText;
      const phoneNumber = contacts[i].querySelector('td:nth-child(3)').innerText;
      const memo = contacts[i].querySelector('td:nth-child(4)').innerText;

      if (!this.validateContact(name, email, phoneNumber, memo)) {
        return;
      }

      let contactName = `<input type="hidden" name="contacts[${i}].name" value="${name}" >`;
      let contactEmail = `<input type="hidden" name="contacts[${i}].email" value="${email}" >`;
      let contactPhoneNumber = `<input type="hidden" name="contacts[${i}].phoneNumber" value="${phoneNumber}" >`;
      let contactMemo = `<input type="hidden" name="contacts[${i}].memo" value="${memo}" >`;
      this.formTarget.insertAdjacentHTML('beforeend', contactName);
      this.formTarget.insertAdjacentHTML('beforeend', contactEmail);
      this.formTarget.insertAdjacentHTML('beforeend', contactPhoneNumber);
      this.formTarget.insertAdjacentHTML('beforeend', contactMemo);
    }
    this.formTarget.submit();
  }

  validateAddressBook() {
    const addressName = this.nameInputTarget.value;
    if (addressName.trim().length === 0 || addressName.length > 100) {
      sendAlert('주소록 이름은 필수로 100자 이내로 기입해주세요.');
      return false;
    }
    return true;
  }

  validateContact(name, email, phoneNumber, memo) {
    if (name.trim().length === 0 || name.length > 100) {
      sendAlert('이름은 필수로 100자 이내로 기입해주세요.');
      return false;
    }
    if (email.length > 0 && !email.match(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/g)) {
      sendAlert('이메일 양식에 맞춰주세요.');
      return false;
    }
    if (phoneNumber.length > 0 && (phoneNumber.length < 10 || phoneNumber.length > 11)) {
      sendAlert('휴대폰번호는 10자이상 11자 이하로 기입해주세요.');
      return false;
    }
    if (phoneNumber.length > 0 && !phoneNumber.match(/^(\d{2,3})(\d{3,4})(\d{4})$/g)) {
      sendAlert('휴대폰 번호는 숫자로만 입력해 주세요.');
      return false;
    }
    if (memo.length > 100) {
      sendAlert('메모 100자 이내로 기입해주세요.');
      return false;
    }
    if (email.length === 0 && phoneNumber.length === 0) {
      sendAlert('이메일 또는 휴대폰번호 둘 중 하나 입력이 필요합니다');
      return false;
    }
    return true;
  }
}
